<div class="tw-mt-1.5 tw-inline-flex tw-items-center tw-text-imperial-red">
  <ia-icons name="xmark_alt" class="tw-w-4 tw-shrink-0" color="currentColor" />
  <p class="tw-ml-2 tw-font-sans">
    {{ message }}
  </p>
</div>
